import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "about", label: "About" },
  { id: "entertainment", label: "Entertainment" },
  { id: "gallery", label: "Gallery" },
  { id: "staff", label: "The Team" },
  { id: "hours", label: "Hours" },
  { id: "contact", label: "Contact" },
];

export default function Navigation({ onBook }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" className="font-serif text-2xl tracking-tight text-white" data-testid="brand-logo">
          Next <span className="text-[#D4AF37]">·</span> Bar &amp; Lounge
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="text-xs tracking-[0.25em] uppercase text-neutral-300 hover:text-[#D4AF37] transition-colors"
              data-testid={`nav-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          onClick={onBook}
          className="hidden md:inline-flex bg-[#D4AF37] text-black font-medium tracking-[0.2em] uppercase text-xs py-3 px-6 hover:bg-[#C5A028] transition-colors"
          data-testid="nav-book-btn"
        >
          Book Event
        </button>
        <button
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 space-y-4">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="block w-full text-left text-sm tracking-[0.25em] uppercase text-neutral-300 hover:text-[#D4AF37]"
              data-testid={`nav-mobile-${l.id}`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => { setOpen(false); onBook(); }}
            className="w-full bg-[#D4AF37] text-black font-medium tracking-[0.2em] uppercase text-xs py-3 px-6"
            data-testid="nav-mobile-book-btn"
          >
            Book Event
          </button>
        </div>
      )}
    </header>
  );
}
